import { Link } from "react-router-dom";
import { RegisterForm } from "./RegisterForm";
import { useTranslation } from "react-i18next";

export const Register: React.FunctionComponent = () => {
const { t } = useTranslation();
  return (
    <>
      <div className="container mx-auto">
        <section className="flex flex-col md:flex-row items-center mx-0 mb-8">
          <div className="hidden md:block w-full md:max-w-md lg:max-w-full md:mx-auto md:w-1/2 xl:w-2/3 px-6 lg:px-16 xl:px-12">
            <div className="w-full p-5 flex items-center justify-center">
              <div className="">

                <div className="py-3 text-2xl font-semibold">
                  <p className="text-3xl font-bold leading-tight">
                    {t('create_account_title')}
                  </p>
                </div>
                <div className="py-5">
                  <p className="text-lg font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                    {t('create_account_description')}
                  </p>
                </div>
                <div className="py-5">
                  <div className="">
                    <div>
                      {t('signin_prompt')}
                      <span className="px-3">
                        <Link
                          to="/auth/login"
                          className="text-sky-600 font-medium	"
                        >
                         {t('signin_prompt_2')}
                        </Link>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-indigo w-full md:max-w-md lg:max-w-full md:mx-auto md:w-1/2 xl:w-1/2 px-6 lg:px-16 xl:px-12">
            <RegisterForm />
          </div>
        </section>
      </div>
    </>
  );
};
